// @flow
import React, { type Node } from 'react'

import styles from './DoubleEntries.scss'

type Props = {
  children: Node,
  paddingRight?: number,
}

const DoubleEntries = ({ children, paddingRight }: Props) => {
  return (
    <div className={styles.root} style={{ paddingRight }}>
      {children}
    </div>
  )
}

export default DoubleEntries
